module.exports = __webpack_public_path__ + "assets/static/media/logo-1.7bfd115e.png";